import { computed, MaybeRef, unref } from 'vue'
import { RateType } from '@/gql/graphql'
import { $t } from '@/composables/translation'
import { durationRateTypeUnitLabels } from '@/components/Job/functions/durationRateTypeUnitLabels'

export type RateCardBandAmounts =
  | {
      minimum?: string | number | null
      maximum?: string | number | null
      rateType?: RateType | string | null
    }
  | null
  | undefined

const formatAmount = (amount: number | string) => Number(amount).toFixed(2)

export function formatRateCardAmountRange(
  minimum: number | string,
  maximum: number | string,
  currency: string,
  separator = '–',
): string {
  const min = formatAmount(minimum)
  const max = formatAmount(maximum)

  return min === max ? `${currency} ${min}` : `${currency} ${min}${separator}${max}`
}

// Shared by every rate-card guidance composable — formats "$ 50.00 – 80.00 per hour", or just the
// amount for a fixed-rate band whose minimum equals its maximum.
export function useRateCardBandRangeText(
  band: MaybeRef<RateCardBandAmounts>,
  currencySymbol: MaybeRef<string>,
) {
  return computed(() => {
    const value = unref(band)
    if (value?.minimum == null || value?.maximum == null) return null

    const currency = unref(currencySymbol)
    const unit = durationRateTypeUnitLabels()[value.rateType as RateType]
    const amount = formatRateCardAmountRange(value.minimum, value.maximum, currency, ' – ')

    return unit ? `${amount} ${$t('per :unit', { unit })}` : amount
  })
}
